module.exports = __webpack_public_path__ + "assets/img/3025.d1e7bba5.svg";